




















































































































































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import { Gender, ICustomer } from "@/interface";
import { AxiosResponse } from "axios";

@Component({
  components: {
    AlertBox,
    DatePicker
  }
})
export default class NewCustomerModal extends Mixins(FormErrorsMixin) {
  @Prop({ default: false }) readonly showModal!: boolean;

  public updating = false;
  private dateFormat = "DD.MM.YYYY";
  private failedRequest = false;
  private errorMessage = "";
  private newCustomer: ICustomer = {
    first_name: null,
    last_name: null,
    gender: null,
    title: null,
    email: null,
    birthdate: null,
    color_code: null,
    note: null,
    position: null,
    number: null,
    phone_number: {
      prefix: null,
      number: null
    }
  };
  public validatedInputs: Array<string> = [
    "first_name",
    "last_name",
    "gender",
    "title",
    "email",
    "birthdate",
    "color_code",
    "note",
    "position",
    "number",
    "phone_number.prefix",
    "phone_number.number"
  ];

  private parseBirthdate(val?: Date): void {
    if (
      this.newCustomer.birthdate != null &&
      Object.prototype.toString.call(this.newCustomer.birthdate) ===
        "[object Date]"
    ) {
      let val: Date = this.newCustomer.birthdate;
      this.newCustomer.birthdate = new Date(
        val.getFullYear() +
          "-" +
          (val.getMonth() + 1 > 9 ? "" : "0") +
          (val.getMonth() + 1) +
          "-" +
          (val.getDate() > 9 ? "" : "0") +
          val.getDate()
      );
    } else if (this.newCustomer.birthdate != null && val != null) {
      let parts: Array<string> = this.newCustomer.birthdate
        .toString()
        .split("-");
      this.newCustomer.birthdate = new Date(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2])
      );
    } else if (this.newCustomer.birthdate != null && val == null) {
      let parts: Array<string> = this.newCustomer.birthdate
        .toString()
        .split(".");
      this.newCustomer.birthdate = new Date(
        parts[2] + "-" + parts[1] + "-" + parts[0]
      );
    }
  }

  private createCustomer(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint("customers");

    this.parseBirthdate();

    Api()
      .post(endpoint, this.newCustomer)
      .then((response: AxiosResponse) => {
        this.failedRequest = false;
        swal("Success!", "The customer was created.", "success");
        this.closeModal(response.data.data);
      })
      .catch((error: any) => {
        this.failedRequest = true;
        this.storeErrors(error.response.data.errors);

        if (error.response.status / 100 === 5) {
          this.errorMessage = "An error occurred.";
        }
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private closeModal(newCustomer: ICustomer): void {
    if (newCustomer) {
      this.$emit("onSuccess", newCustomer);
    } else {
      this.$emit("close");
    }
    this.newCustomer = {
      first_name: null,
      last_name: null,
      gender: null,
      title: null,
      email: null,
      birthdate: null,
      color_code: null,
      note: null,
      position: null,
      number: null,
      phone_number: {
        prefix: null,
        number: null
      }
    };
  }

  private toggleGender(gender: Gender): void {
    if (gender === this.newCustomer.gender) {
      if (gender === 2) {
        this.newCustomer.gender = 1;
      } else {
        this.newCustomer.gender = 2;
      }
    } else {
      this.newCustomer.gender = gender;
    }
  }
}
